module.exports = new __parcel__URL__("machine_claim_button.bde4779a.png").toString();